// qs-type-silhouette.ts
export interface Silhouette {
  id: string
  name: string
  filename: string
  preview: string
  path: string
  category?: string
  isCustom?: boolean
  originalDimensions?: { width: number, height: number }
}

export interface SilhouetteState {
  currentSilhouette: Silhouette | null
  isVisible: boolean
  color: string
  availableSilhouettes: Silhouette[]
}

export interface SilhouetteControlProps {
  currentSilhouette?: Silhouette | null
  isVisible?: boolean
  color?: string
}

export interface SilhouetteControlEmits {
  'silhouette-changed': [silhouette: Silhouette]
  'visibility-changed': [visible: boolean]
  'color-changed': [color: string]
  'open-selection': []
}

export interface SilhouetteSelectionModalProps {
  currentSilhouette?: Silhouette | null
  availableSilhouettes: Silhouette[]
}

export interface SilhouetteSelectionModalEmits {
  'silhouette-selected': [silhouette: Silhouette]
  'close': []
}

export interface SilhouettePreviewProps {
  silhouette: Silhouette
  isSelected?: boolean
  size?: 'small' | 'medium' | 'large'
}

export interface SilhouettePreviewEmits {
  'select': [silhouette: Silhouette]
}

export const DEFAULT_SILHOUETTE_COLOR = 'rgba(166, 166, 166, 0.3)'
export const DEFAULT_SILHOUETTE_VISIBILITY = true

export enum SilhouetteCategory {
  PEOPLE = 'people',
  VEHICLES = 'vehicles',
  ANIMALS = 'animals',
  OBJECTS = 'objects',
  BUILDINGS = 'buildings',
  CUSTOM = 'custom'
}

export interface SilhouetteRegistryEntry {
  id: string
  name: string
  filename: string
  category: SilhouetteCategory
  description?: string
}